export let highlightedRowContainerStyle = {
    borderColor: "#39b4e8",
    borderStyle: "solid",
    borderWidth: "1px",
    borderRadius: "5px",
    paddingTop: "15px",
    marginBottom: "15px"
};
export let rowContainerStyle = {
    borderColor: "#c3c3c3",
    borderStyle: "dashed",
    borderWidth: "1px",
    borderRadius: "5px",
    paddingTop: "15px",
    marginBottom: "15px"
};